<nav class="meganav"
     role="navigation"
     (offClick)="close()"
     [offClickOff]="!client.isTouchy || client.isCms"
     offClickFilter=".meganav__content">
    <ul>

        @for (item of items; track $index; let isFirst = $first) {
        @if (!item.hide) {
        <!-- <ng-container *ifCustomerAllowed="item.visibility"> -->
        <li class="inline-block"
            [gtmTrackNavigationClick]="{
                        event: 'nav_category_click',
                        nav_category: item.text,
                        link_url: item.link,
                        link_text: item.text}"
            [attr.cy-navCategory]="item.link ? item.link : 'empty'"
            [toggleClass]="'is-active'"
            [toggleClassBy]="[meganavToggleGroupId, $index + (tabIndex * 20)]">
            <href class="cursor-pointer meganav__item p2 p-b-9"
                  [ngClass]="item.color ? item.color + ' ' + 'force-cms-colour' : ''"
                  [link]="item.link"
                  (mouseenter)="handleMouseEnter($index, item)"
                  (mouseleave)="handleMouseLeave($index)"
                  (click)="handleClick($index)"
                  *iCms="'text' of item">
            </href>
        </li>
        <!-- </ng-container> -->
        }
        }
    </ul>
</nav>
